/**
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

import $ from 'jquery';
import 'mage/mage';
import 'Magento_Customer/js/customer-data';

export default function (config) {
    const $dataForm = $('#' + config.formId);

    $dataForm.find(':submit').prop('disabled', false).removeClass('_initial');
    $dataForm.attr('action', config.formAction);

    $dataForm.submit(function () {
        $dataForm.find(':submit').attr('disabled', 'disabled');

        if (this.isValid === false) {
            $dataForm.find(':submit').prop('disabled', false);
        }
        this.isValid = true;
    });

    $dataForm.bind('invalid-form.validate', function () {
        $dataForm.find(':submit').prop('disabled', false);
        this.isValid = false;
    });
}
